import type { InstructorProfile } from './types';

export const instructorRegistry:Record<string,InstructorProfile>={
  'kojo-mensah':{id:'kojo-mensah',name:'Mr. Kojo Mensah',role:'Pulkra Mentor — Project Finance and Construction Business',description:'A calm Ghanaian executive educator with construction-business experience, wearing a navy blazer and white shirt.'}
};
